<template>
  <svg :width="width" :height="height" :viewBox="viewBox" :fill="fill">
    <rect x="3.60034" y="0.5" width="10.7992" height="17" rx="1.5" :stroke="stroke" stroke-linejoin="round"/>
    <line x1="7.40063" y1="14.801" x2="10.6003" y2="14.801" :stroke="stroke" stroke-linecap="round"/>
  </svg>
</template>
<script>
export default {
  props: {
    iconName: {type: String, default: 'box'},
    width: {type: [Number, String], default: 18},
    height: {type: [Number, String], default: 18},
    stroke: {type: String, default: 'currentColor'},
    viewBox: {type: String, default: '0 0 18 18'},
    fill: {type: String, default: 'none'}
  }
}
</script>